import React, {CSSProperties} from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import './QuestionCheckCorrect.scss';
import {duotone} from '@fortawesome/fontawesome-svg-core/import.macro';

interface QuestionCheckCorrectProps {
  onClick?: () => void;
}

export const QuestionCheckCorrect: React.FC<QuestionCheckCorrectProps> = (props) => {
  // Hackish solution for now https://github.com/FortAwesome/react-fontawesome/issues/259
  const duotoneIconStyle: CSSProperties = {
    '--fa-primary-color': 'white',
    '--fa-secondary-opacity': 1,
  } as CSSProperties;

  return (
    <FontAwesomeIcon
      onClick={props.onClick}
      icon={duotone('check-circle')}
      style={duotoneIconStyle}
      className="question-check-correct"
      size="lg"
    />
  );
};
